export default () => ({
  init() {
    // Small delay to ensure DOM is ready
    setTimeout(() => {
      this.initializeHeaderHeights();
    }, 100);
  },

  initializeHeaderHeights() {
    const headerElement = document.getElementById("header");
    const uspBarElement = document.getElementById("usp-bar");

    if (!headerElement || !uspBarElement) {
      console.warn("Header or USP bar elements not found");
      return;
    }

    let headerHeight = 0;
    let uspBarHeight = 0;
    let debounceTimer = null;

    const updateHeights = () => {
      try {
        // Get current heights
        const newHeaderHeight = headerElement.offsetHeight;
        const newUspBarHeight = uspBarElement.offsetHeight;

        // Only update if heights changed
        if (
          newHeaderHeight !== headerHeight ||
          newUspBarHeight !== uspBarHeight
        ) {
          headerHeight = newHeaderHeight;
          uspBarHeight = newUspBarHeight;

          // Update individual height variables
          document.documentElement.style.setProperty(
            "--header-bar-height",
            `${headerHeight}px`
          );
          document.documentElement.style.setProperty(
            "--usp-bar-height",
            `${uspBarHeight}px`
          );

          // Update combined height variable
          const totalHeight = headerHeight + uspBarHeight;
          document.documentElement.style.setProperty(
            "--combined-header-usp-height",
            `${totalHeight}px`
          );

          // Update content area height
          document.documentElement.style.setProperty(
            "--content-area-height",
            `calc(100vh - ${totalHeight}px)`
          );
        }
      } catch (error) {
        console.warn("Failed to update header heights:", error);
      }
    };

    const debouncedHeightUpdate = () => {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(updateHeights, 16);
    };

    // Initial height update
    updateHeights();

    // Observe both elements for size changes
    try {
      const resizeObserver = new ResizeObserver(() => {
        requestAnimationFrame(debouncedHeightUpdate);
      });

      // Observe both header and usp-bar elements
      resizeObserver.observe(headerElement);
      resizeObserver.observe(uspBarElement);

      this.$cleanup = () => {
        resizeObserver.disconnect();
        clearTimeout(debounceTimer);
      };
    } catch (error) {
      // Fallback to resize event if ResizeObserver is not supported
      console.warn("ResizeObserver not supported, using resize event fallback");
      window.addEventListener("resize", debouncedHeightUpdate, {
        passive: true,
      });

      this.$cleanup = () => {
        window.removeEventListener("resize", debouncedHeightUpdate);
        clearTimeout(debounceTimer);
      };
    }
  },
});
